'use client'

export const Stamp = (props: { text?: string }) => {
  if (!props.text) return null

  return (
    <div className="rounded-[4px] bg-bodi-green-bright-500 px-2 font-sans text-body-sm font-medium text-bodi-black-text">
      {props.text}
    </div>
  )
}
